import { enableTrackingAndAnalytics } from '../consentManager/tagHelpers';
import { TrackingEvent } from './types';

const enableTagManager = enableTrackingAndAnalytics();
let initialized = false;

const tagManagerId = 'GTM-5WTBR3Z';
const trackingIdGA4 = 'G-TDQQKJDD8S';

function addConsentModeSettings(): void {
  const script = document.createElement('script');
  script.textContent = `window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('consent', 'default', {
  'ad_storage': 'denied',
  'analytics_storage': 'denied',
  'wait_for_update': 500
});
dataLayer.push({
  'event': 'default_consent'
});`;

  const { head } = document;
  head.append(script);
}

function addTagManager(): void {
  const { head } = document;
  const tagManagerScript = document.createElement('script');
  tagManagerScript.textContent = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${tagManagerId}');`;
  head.append(tagManagerScript);
}

function initialize(): void {
  if (!enableTagManager || typeof document === 'undefined') {
    return;
  }

  initialized = true;

  addConsentModeSettings();
  addTagManager();
}

function isInitialized(): boolean {
  return !!initialized;
}

function getGTag(): ((...args: unknown[]) => void) | null {
  if (typeof window === 'undefined' || !initialized) {
    return null;
  }
  const { gtag } = window;
  if (!gtag) {
    console.error('gtag not yet initialized');
    return null;
  }
  return gtag;
}

function event(eventName: string, properties: object): void {
  const gTag = getGTag();
  if (!gTag) {
    return;
  }
  gTag('event', eventName, { send_to: trackingIdGA4, ...properties });
}

function trackEvent(trackingEvent: TrackingEvent): void {
  event(trackingEvent.event, trackingEvent.parameters);
}

export default { initialize, isInitialized, event, trackEvent };
